<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<Header></Header>
		<div class="page_content">
			<!--面包屑与公共提醒-开始-->
			<div class="ext_head">
				<div class="bread_crumb"><a href="/tw/">首頁</a><span class="space">/</span>旅遊套餐</div>
			</div>
			<!--面包屑与公共提醒-结束-->
			<!--页面内容-开始-->
			<div class="public_content">
				
				<!--左侧-开始-->
				<div class="left_box">
					<div class="section_box">
						<h1>搜尋條件</h1>
						<div class="search_box">
							<input type="text" class="input_keyword" v-model="keyword" maxlength="50" placeholder="請輸入您感興趣的內容" @keyup.enter="searchHandle()" />
							<div class="btn_search" @click="searchHandle()"></div>
						</div>
					</div>
					<div class="section_box">
						<h1>篩選條件</h1>
						<div class="filter_box">
							<div class="items_box">
								<div class="ft_title">
									<h4>按目的地</h4>
									<span v-if="!(area==='' || area===null)"><a href="javascript:void(0)" @click="areaClear()">重設</a></span>
								</div>
								<ul>
									<li v-for="item in areaList" :key="item.Id" v-if="item.Id===area" class="selected"><a href="javascript:void(0)" @click="areaHandle(item.Id)">{{item.Title}}</a></li>
									<li v-else><a href="javascript:void(0)" @click="areaHandle(item.Id)">{{item.Title}}</a></li>
								</ul>
							</div>
							<div class="items_box">
								<div class="ft_title">
									<h4>按行程天數</h4>
									<span v-if="!(stroke==='' || stroke===null)"><a href="javascript:void(0)" @click="strokeClear()">重設</a></span>
								</div>
								<ul>
									<li v-for="item in strokeList" :key="item.Id" v-if="item.Id===stroke" class="selected"><a href="javascript:void(0)" @click="strokeHandle(item.Id)">{{item.Title}}</a></li>
									<li v-else><a href="javascript:void(0)" @click="strokeHandle(item.Id)">{{item.Title}}</a></li>
								</ul>
							</div>
						</div>
					</div>
				</div>				
				<!--左侧-结束-->
				
				<div class="data_content">
				
					<!--排序-开始-->
					<div class="sort_box">
						<div class="total">
							<template v-if="!fullscreenLoading">
							共 <span class="bold">{{recordTotal}}</span> 條數據
							</template>
						</div>
						<div class="sort">
							<span class="bold">{{sortList[sort].Title}}</span>
							<div class="popup">
								<ul>
									<li v-for="item in sortList" :key="item.Id" v-if="item.Id===sort" class="selected">{{item.Title}}</li>
									<li v-else @click="sortHandle(item.Id)">{{item.Title}}</li>
								</ul>
							</div>
						</div>
					</div>
					<!--排序-结束-->
					
					<!--无数据-->
					<NoData :isShow="noDataIsShow"></NoData>
					
					<!--列表-开始-->
					<div class="items">
						
						<div class="item_box" v-for="(item, index) in productList" :key="index">
							<a :href="'product/detail?Id='+item.ProductId" target="_blank"><img :src="item.Picture" /></a>
							<div class="right_box">
								<h3><a :href="'product/detail?Id='+item.ProductId" target="_blank">{{truncatedMessage(item.Title,80)}}</a></h3>
								<h4>行程天數：<b>{{item.StrokeDays}}</b>&nbsp;&nbsp;&nbsp;&nbsp;住宿方案：<b>{{item.HotelPlan}}</b> 套</h4>
								<h4>有效期：{{item.ValidityDate}}</h4>
								<div class="bottom_box">
									<div class="comment_box">
										<!-- <template v-if="item.Comments.Amount>0">
										<span class="num">{{item.Comments.StarNumber}}</span><span class="total">共{{item.Comments.Amount}}條評論</span>
										</template>
										<template v-else>
										<span class="total">暫無任何評論</span>
										</template> -->
									</div>
									<div class="price_box">
										<div class="price">
											<!-- <span class="show_price">${{item.ShowPrice}}</span> -->
											<span class="sale_price">${{item.Price}}<em> 起</em></span>
										</div>
										<div class="tips">該價格已包含度假村費</div>
									</div>
								</div>
							</div>
						</div>
						
					</div>
					<!--列表-结束-->
					
					<!--分页-开始-->
					<div class="page_ctrl" v-if="this.productList.length>0">
						<el-pagination layout="prev, pager, next" :total="recordTotal" :current-page="pageIndex"
							:pager-count="5" :page-size="pageSize" :background="true" @current-change="handleCurrentChange">
						</el-pagination>
					</div>
					<!--分页-结束-->
					
				</div>
				
			</div>
			<!--页面内容-结束-->
		</div>
		<Footer></Footer>
	</div>
</template>


<script>
	import {
		getArea,
		getSchedule,
		getStrokeDays,
		getHotAttractions,
		getProductList
	} from '@/api/index.js'
	import { mixin } from '@/utils/mixin.js'
	import Header from '@/components/tw_header.vue'
	import Footer from '@/components/tw_footer.vue'
	import NoData from '@/components/tw_noData.vue'
	export default {
		name: 'TW_ProductList',
		mixins:[mixin],
		components: {
			Header,
			Footer,
			NoData,
		},
		data() {
			return {				
				fullscreenLoading: false, //loading状态
				noDataIsShow: false, //无数据缺省
				language: 'tw', 	//语言版本
				area: null,			//目的地
				stroke: null,		//行程天数
				sort: 0,			//排序
				keyword: '',		//关键词
				pageIndex: 1, 		//页码，默认为1
				pageSize: 10, 		//每页显示条数
				pageTotal: 0, 		//总页数
				recordTotal: 0, 	//总条数
				pageSlogan:'',		//Slogan
				areaList: [],		//目的地列表
				strokeList: [],		//行程天数列表				
				productList: [], 	//数据列表
				sortList: [
					{
						Id: 0,
						Title: '按 默認排序'
					},
					{
						Id: 1,
						Title: '按 價格由低到高'
					},
					{
						Id: 2,
						Title: '按 價格由高至低'
					},
				],
			}
		},		
		computed: {
		},
		mounted() {
		},
		created() {
			this.getAreaList()
			this.getStrokeDaysList()
			this.getData()
		},
		methods: {
			// 获取目的地列表
			async getAreaList ()
			{
				const { data: res } = await getArea(this.language)
				if (res.errcode === 0) {
					this.areaList = res.data
				} else {
					this.$message.error(res.errmsg);
				}
			},
			// 获取行程天数列表
			async getStrokeDaysList () {
				const { data: res } = await getStrokeDays(this.language)
				if (res.errcode === 0) {
					this.strokeList = res.data
				} else {
					this.$message.error(res.errmsg);
				}
			},
			// 获取数据列表
			async getData ()
			{
				console.log(this.stroke)
				this.fullscreenLoading = true
				this.ticketList = []
				const {
					data: res
				} = await getProductList(this.language, this.area, this.stroke, this.sort, this.keyword, this.pageIndex)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					this.pageSlogan = res.data.ColumnSlogan
					this.productList = res.data.DataList
					this.pageTotal = res.data.PageTotal
					this.recordTotal = res.data.RecordTotal
					if (res.data.DataList.length > 0) {
						this.noDataIsShow = false
						this.$nextTick(() => {
							window.scrollTo(0, 0);
						});
					} else {
						this.noDataIsShow = true
					}
				} else {
					this.$message.error(res.errmsg);
				}
			},
			// 点选目的地
			areaHandle(Id)
			{
				if(this.area != Id)
				{
					this.area = Id
					this.pageIndex = 1
					this.getData()
				}
			},
			// 清空目的地
			areaClear()
			{
				this.area = null
				this.pageIndex = 1
				this.getData()
			},		
			// 点选行程天数
			strokeHandle(Id)
			{
				if(this.stroke != Id)
				{
					this.stroke = Id
					this.pageIndex = 1
					this.getData()
				}
			},
			// 清空行程天数
			strokeClear()
			{
				this.stroke = null
				this.pageIndex = 1
				this.getData()
			},
			// 排序
			sortHandle(Id)
			{
				this.sort = Id
				console.log(this.sort)
				this.pageIndex = 1
				this.getData()
			},
			// 搜索
			searchHandle()
			{
				this.pageIndex = 1
				this.getData()
			},
			
			//切换页码
			handleCurrentChange(val) {
				this.pageIndex = val
				this.getData()
			},
		}
	}
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		box-sizing: border-box;
		
		/*页面内容*/
		.data_content {
			min-height: 700px;

			/*列表*/
			.items {
				margin-top: 11px;
				width: 100%;
				position: relative;

				.it_s {
					width: 30px;
					height: 330px;
				}
				
				.item_box {
					width: 100%;
					background-color: #fff;
					border: #DFE0E3 solid 1px;
					border-radius: 8px;
					margin-bottom: 24px;
					position: relative;
					display: flex;
					justify-content: space-between;
					-webkit-transition: all .3s ease;
					
					
					img {
						width: 300px;
						height: 200px;
						border-top-left-radius: 7px;
						border-bottom-left-radius: 7px;
						display: block;
					}
					
					.right_box {
						width: 69.5%;
						height: 200px;
						padding: 14px 20px 20px 0;
						box-sizing: border-box;
						position: relative;
						
						h3 {
							margin-bottom: 14px;
							a {
								font-size: 18px;
								font-weight: 500;
								line-height: 160%;
								text-decoration: underline;
							}
						}
						
						h4 {
							margin-top: 6px;
							font-size: 13px;
							font-weight: 400;
						}
						h4.bold {
							font-weight: 500;
						}
						
						.bottom_box {
							width: 100%;
							position: absolute;
							padding: 0 20px 14px 0;
							box-sizing: border-box;
							bottom: 0;
							display: flex;
							justify-content: space-between;
							align-items: flex-end;
							
							.comment_box {
								width: 200px;
								span {
									display: inline-block;
									vertical-align: middle;
								}
								span.num {
									width: 40px;
									height: 24px;
									line-height: 24px;
									background-color: #3D7856;
									border-radius: 5px;
									color: #fff;
									font-size: 13px;
									font-weight: 500;
									text-align: center;
									margin-right: 10px;
								}
								span.total {
									color: #666666;
									font-size: 12px;
								}
							}
							
							.price_box {
								text-align: right;
								
								.price {
									span {
										display: inline-block;
										vertical-align: middle;
									}
									span.show_price {
										font-size: 18px;
										color: #666;
										text-decoration: line-through;
									}
									span.sale_price {
										margin-left: 16px;
										font-size: 24px;
										font-weight: 500;
										
										em {
											font-size: 13px;
											color: #666;
											font-weight: 400;
											vertical-align: middle;
										}
									}
								}
								
								.tips {
									margin-top: 6px;
									font-size: 13px;
									color: #3D7856;
								}
							}
						}
					}
				}
				.item_box:hover {
					background-color: #FAFFF9;
					box-shadow: 0px 0px 8px #ddd;
				}
				
			}
		}
		
		/deep/ .el-pagination {
			font-size: 16px;
		}
		
		/deep/ .el-pager li {
			width: 36px;
			height: 36px;
			font-size: 16px;
			line-height: 36px;
			margin: 0 5px;
			border-radius: 5px;
		}
		
		/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
			background-color: #3D7856;
			font-size: 16px;
		}
		
		/deep/ .el-pagination button {
			width: 36px;
			height: 36px;	
			border-radius: 5px;
		}
		
		/deep/ .el-pagination .btn-next .el-icon {
			font-size: 16px;
		}
		/deep/ .el-pagination .btn-prev .el-icon {			
			font-size: 16px;
		}

		/*左侧*/
		// .product_left {
		// 	min-height: 540px;

		// 	.group {
		// 		width: 100%;
		// 		margin-top: 30px;
				

		// 		.days {
		// 			position: relative;
		// 			overflow: hidden;
		// 			height: 36px;
		// 			line-height: 36px;
		// 			background-image: url(@/assets/images/icons/space_line.png);
		// 			background-position: left center;
		// 			background-repeat: repeat-x;
		// 			font-size: 15px;

		// 			.title {
		// 				height: 36px;
		// 				line-height: 36px;
		// 				display: inline-block;
		// 				background: #008768;
		// 				color: #fff;
		// 				padding: 0 20px;
		// 				border-radius: 18px;

		// 				span {
		// 					font-size: 18px;
		// 					font-weight: 500;
		// 				}
		// 			}
		// 		}
				
		// 		.without_box {
		// 			padding: 30px 0;
		// 			text-align: center;
		// 			font-size: 13px;
		// 			color: #999;
		// 		}
				
		// 		.carouse_box {
		// 			position: relative;
		// 			overflow: hidden;
		// 			width: 100%;
		// 			margin-top: 30px;
		// 		}

		// 		.items {
		// 			display: flex;
		// 			transition: transform 0.3s ease;
		// 			padding: 5px;
					
		// 			.item_box {
		// 				width: 330px;
		// 			}

		// 			.item {
		// 				width: 310px;
		// 				box-sizing: border-box;
		// 				min-height: 320px;
		// 				margin: 0 auto;
		// 				padding-bottom: 8px;
		// 				border-radius: 10px;
		// 				-webkit-transition: all .5s ease;

		// 				.picture {
		// 					position: relative;
		// 					overflow: hidden;
		// 					border-radius: 10px;

		// 					.days_tag {
		// 						position: absolute;
		// 						z-index: 1000;
		// 						left: 10px;
		// 						top: 14px;
								
		// 						span {
		// 							display: inline-block;
		// 							vertical-align: middle;
		// 							margin: 0 5px;
		// 							height: 24px;
		// 							line-height: 24px;
		// 							padding: 0 10px;
		// 							background: #000;
		// 							font-size: 12px;
		// 							color: #fff;
		// 							border-radius: 12px;
		// 						}
								
		// 						.arr_0 {
		// 							background-color: #11c855;
		// 							color: #fff;
		// 						}
		// 						.arr_1 {
		// 							background-color: #00a43d;
		// 							color: #fff;
		// 						}
		// 						.arr_2 {
		// 							background-color: #ff6600;
		// 							color: #fff;
		// 						}
		// 					}

		// 					img {
		// 						width: 100%;
		// 						height: 208px;
		// 						border-radius: 10px;
		// 						display: block;
		// 						cursor: pointer !important;
		// 						-webkit-transition: all .5s ease;
		// 					}
		// 				}

		// 				.information {
		// 					padding: 0 10px;

		// 					.title {
		// 						margin-top: 8px;
		// 						font-size: 14px;
		// 						font-weight: 500;
		// 						line-height: 150%;
		// 						cursor: pointer !important;
		// 					}

		// 					.validity {
		// 						margin-top: 8px;
		// 						font-size: 12px;
		// 						color: #666;
		// 					}

		// 					.plan_price {
		// 						margin-top: 2px;
		// 						display: flex;
		// 						justify-content: space-between;
		// 						font-size: 13px;
		// 						color: #333;

		// 						.plan {
		// 							padding-left: 20px;
		// 							height: 20px;
		// 							line-height: 20px;
		// 							background-image: url(@/assets/images/icons/hotel.png);
		// 							background-position: left center;
		// 							background-repeat: no-repeat;
		// 							background-size: 14px 16px;

		// 							span {
		// 								font-weight: 500;
		// 								display: inline-block;
		// 								vertical-align: bottom;
		// 								margin: 0 4px;
		// 							}
		// 						}

		// 						.price {
		// 							font-size: 12px;
		// 							color: #666;

		// 							span {
		// 								font-size: 16px;
		// 								font-weight: 500;
		// 								color: #000;
		// 								display: inline-block;
		// 								vertical-align: top;
		// 								margin-right: 4px;
		// 							}
		// 						}
		// 					}
		// 				}

		// 			}

		// 			.item:hover {
		// 				background: #fff;
		// 				box-shadow: 0 0 10px #dedede;
		// 				margin-top: -5px;						
						
		// 				.picture {
		// 					border-bottom-left-radius: 0;
		// 					border-bottom-right-radius: 0;
		// 				}

		// 				img {
		// 					border-bottom-left-radius: 0;
		// 					border-bottom-right-radius: 0;
		// 					transform: scale(1.05);
		// 					-webkit-transform: scale(1.05);
		// 				}

		// 				.title {
		// 					text-decoration: underline;
		// 				}
		// 			}
		// 		}

		// 		.arrows {
		// 			width: 110px;
		// 			height: 32px;
		// 			margin: 30px auto;
		// 			display: flex;
		// 			justify-content: space-between;

		// 			.arr {
		// 				width: 32px;
		// 				height: 32px;
		// 				background-position: center;
		// 				background-repeat: no-repeat;
		// 				background-size: 7px 12px;
		// 				background-color: #fff;
		// 				border-radius: 16px;
		// 				border: #F4F4F4 solid 1px;
		// 				cursor: pointer !important;
		// 				box-shadow: 0 0 5px #eee;
		// 				-webkit-transition: all .2s ease;
		// 			}

		// 			.arr:hover {
		// 				box-shadow: 0 0 5px #DEF8FF;
		// 				background-color: #f0f7ff;
		// 			}

		// 			.left {
		// 				background-image: url(@/assets/images/icons/arrow_left.png);
		// 			}

		// 			.right {
		// 				background-image: url(@/assets/images/icons/arrow_right.png);
		// 			}

		// 			.l_gray {
		// 				background-image: url(@/assets/images/icons/arrow_left_gray.png);
		// 			}

		// 			.l_gray:hover {
		// 				background-color: #fff;
		// 				box-shadow: 0 0 5px #eee;
		// 			}

		// 			.r_gray {
		// 				background-image: url(@/assets/images/icons/arrow_right_gray.png);
		// 			}

		// 			.r_gray:hover {
		// 				background-color: #fff;
		// 				box-shadow: 0 0 5px #eee;
		// 			}
		// 		}
		// 	}

		// 	.group:last-child {
		// 		margin-bottom: 30px;
		// 	}
		// }

		/*右侧*/
		// .page_right {
		// 	margin-top: 65px;
		// 	width: 320px;
		// }
		
	}
</style>